import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from 'react-router-dom';
import studi from './../../assets/img/books/aspassotraipianeti/studi.jpg';
import tavola1 from './../../assets/img/books/aspassotraipianeti/01.jpg';
import tavola2 from './../../assets/img/books/aspassotraipianeti/02.jpg';
import tavola3 from './../../assets/img/books/aspassotraipianeti/03.jpg';

function ASpassoTraIPianeti() {
  const navigation = useNavigate();
  return (
    <Grid
      container
      spacing={2}
      style={{
        display: 'flex',
        alignContent: 'center',
        flexDirection: 'column',
        alignItems:'center',
      }}
    >
      <img className="book-image" src={studi} alt="" />
      <img className="book-image" src={tavola1} alt="" />
      <img className="book-image" src={tavola2} alt="" />
      <img className="book-image" src={tavola3} alt="" />
      <Grid>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIosIcon />}
          onClick={() => navigation('/books')}
        >
          Back
        </Button>
      </Grid>
    </Grid>
  );
}

export default ASpassoTraIPianeti;
